import React from "react";
import ReactDOM from "react-dom/client";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig, msalEnabled } from "./auth/msalConfig";
import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

function renderApp(msalInstance?: PublicClientApplication) {
  root.render(
    msalEnabled && msalInstance ? (
      // Azure AD mode: MsalProvider gives MSAL hooks access throughout the tree
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    ) : (
      // Dev / guest mode: no login required
      <App />
    )
  );
}

if (msalEnabled) {
  // MSAL v5 requires initialize() before any render so it can
  // process the redirect response and detect existing SSO sessions.
  const msalInstance = new PublicClientApplication(msalConfig);
  msalInstance
    .initialize()
    .then(() => renderApp(msalInstance))
    .catch((err) => {
      console.error("MSAL initialization failed:", err);
      renderApp(); // fall back to guest mode rather than a blank screen
    });
} else {
  renderApp();
}

reportWebVitals();
